<template>
     <v-card-text>
       <v-form v-model="formValid">
         <v-text-field
          autofocus
          v-model='dataModel[modifyIndex].name'
          :label="`First name of ${formType[0]} ${relativeName} (optional)`"
          ></v-text-field>
          
          <span v-if='dataModel[modifyIndex] && (dataModel[modifyIndex].id === dataModel[modifyIndex].name || dataModel[modifyIndex].name === "" )'>Is {{formType[0]}} {{relativeName}} living?</span>
          <span v-else>Is {{dataModel[modifyIndex].name}} living?</span>

           <v-radio-group  v-model='dataModel[modifyIndex].isLiving'  true-value="true" false-value="false">
        <v-radio
        label="Yes"
         :value="true"
      ></v-radio>
      <v-radio
        label="No"
         :value="false"
      ></v-radio>
         </v-radio-group>
          <v-text-field
          @focus="$event.target.select()"
          type="tel"
          pattern="[0-9]*"
          v-model="dataModel[modifyIndex].age"
          :rules='ageRules'
          :label="ageText()"> </v-text-field>
           <span v-if='dataModel[modifyIndex] && (dataModel[modifyIndex].id === dataModel[modifyIndex].name || dataModel[modifyIndex].name === "" )'>Has {{formType[0]}} {{relativeName}} ever been diagnosed with cancer?</span>
         <span v-else>Has {{dataModel[modifyIndex].name}} ever been diagnosed with cancer? </span>
        <Cancer v-if='modifyIndex !== null' :modifyIndex="modifyIndex"/>
         <span v-if='dataModel[modifyIndex] && (dataModel[modifyIndex].id === dataModel[modifyIndex].name || dataModel[modifyIndex].name === "" )'>Has {{formType[0]}} {{relativeName}} completed any genetic testing previously?</span>
         <span v-else>Has {{dataModel[modifyIndex].name}} completed any genetic testing previously?</span>
         <CancerTest  v-if='modifyIndex !== null' :modifyIndex="modifyIndex" />
           <v-textarea
          v-model="dataModel[modifyIndex].notes"
          outline
          name="input-7-4"
          label="Notes"
          value=""
        ></v-textarea>
          
          </v-form>
           </v-card-text>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import Cancer from './Cancer.vue'
import CancerTest from './CancerTest.vue'
export default {
    props : {
        relativeName : String,
        modifyIndex : Number,
        formType : Array
    } ,
       components : {
     Cancer,
     CancerTest
   },
    mounted() {
     
    },
    data : () =>({
      ageRules: [v => (v && v >= 0) || 'Age must be larger or equal to 0'],
    }),
    methods : {
 ageText() {
       if(this.dataModel[this.modifyIndex].isLiving){
            if(this.dataModel[this.modifyIndex].name == ""){
               return 'What is '+this.formType[0] + " "+ this.relativeName+'\'s age?'
            }
            return 'What is '+this.dataModel[this.modifyIndex].name+'\'s age?'
          }
          else{
            if(this.dataModel[this.modifyIndex].name == ""){
              return 'What is '+this.formType[0] + " "+ this.relativeName+'\'s age of passing?'
            }
            return 'What is '+this.dataModel[this.modifyIndex].name+'\'s age of passing?'
          }
    },
    },
     computed: {
       ...mapFields('patientQuestion',[
         'dataModel','formValid'
    ])
     }
}
</script>
